// 为了减少小程序体积，导出方法并 boudle，同时防止其中使用了 web 运行环境
export { printWarn, throwError } from '@cloudbase/utilities/dist/cjs/libs/util'
export { ERRORS, COMMUNITY_SITE_URL } from '@cloudbase/utilities/dist/cjs/constants'
export { catchErrorsDecorator } from '@cloudbase/utilities/dist/cjs/helpers'
export { CloudbaseEventEmitter } from '@cloudbase/utilities/dist/cjs/libs/events'
export { CloudbaseCache } from '@cloudbase/utilities/dist/cjs/libs/cache'
export { default as adapterForWxMp } from '@cloudbase/adapter-wx_mp'
export { useDefaultAdapter } from '@cloudbase/utilities/dist/cjs/adapters'
